/* eslint-disable max-lines-per-function */
/* eslint-disable max-lines */
/* eslint-disable lodash/import-scope */
import {
  CAN_EDIT_ACCOUNT_TYPES,
  FEATURE_FLAGS_NAMES
} from '@linearb/linjs-common';
import history from 'common/RouterHistory';
import {
  TEAM_TYPES,
  DASHBOARD_INTERNAL_TYPES,
  SESSION_STORAGE_KEYS,
  SETTING_NAMES,
  TRACKING
} from 'common/constants/constants';
import { usePullRequestLabels } from 'common/fetchHooks/usePullRequestLabels';
import * as TrackingService from 'common/services/tracking.service';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import { calculateDateRangeBasedOnRetentionAndMaxRetention } from 'common/utils/time.utils';
import { downloadLink, getRetentionDaysByLicense } from 'common/utils/utils';
import ExportFile from 'components/ExportFile';
import { MenuButtonItem } from 'components/MenuButton';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';
import { Margin, WhiteSection } from 'components/base/layout-components';
import useSettingsService from 'components/hooks/useSettingsService';
import useToast from 'components/hooks/useToast';
import _ from 'lodash';
import debounce from 'lodash/debounce';
import { deleteDashboardModalOption } from 'modals/modal-options-factory';
import { useEffect, useRef, useState } from 'react';
import { GridContextProvider, GridDropZone, swap } from 'react-grid-dnd';
import { useSelector } from 'react-redux';
import { teamsWithExtraSyncedDataSelector } from 'state/selectors/teams';
import { PerformanceTopBar } from '../../../PerformanceTopBar/PerformanceTopBar';
import { EMPTY_DEFAULT_REPORT } from '../../../reportsConfiguration';
import TeamGoalsAllTeams from '../EmptyStates/TeamGoalsAllTeams';
import TeamGoalsEmptyState from '../EmptyStates/TeamGoalsEmptyState';
import TeamGoalsUpgradeEmptyState from '../EmptyStates/TeamGoalsUpgradeEmptyState';
import Filters from '../Filters/Filters';
import { isEqualAllTeams } from '../Filters/TeamsDropdown';
import { NewGraphBox } from '../GraphBox';
import {
  EMPTY_DUMMY_ORG_LEVEL_TEAM_GOALS_DASHBOARD,
  FILTER_BY,
  TEAM_GOALS_WIDGETS_ORDER,
  DEFAULT_REPORT_IDS
} from '../consts';
import {
  calculateAddButtonPosition,
  calculateReportHeight,
  checkIfIsPmCustomDashboard,
  localStorageService
} from '../custom-report.serivce';
import { LICENSE_SHOW_EMPTY_STATE_FOR_TEAM_GOALS } from '../goals.service';
import useCustomReport from '../custom-hooks/useCustomReport';
import CustomWidget from '../Widgets/CustomWidget/CustomWidget';
import { getMetricType } from '../Widgets/utils/metrics';
import PMWidgetsDeprecationNotice from '../PMWidgetsDeprecationNotice';
import { AddGraph, GraphItem, GraphsContainer } from './CustomReport.new.style';
import { PmDataProvider } from 'common/contexts/PmDataContext';
import TeamGoalsCTA from 'components/CtaPage/teamGoalsCta/TeamGoalsCTA';
import {
  shouldHidePremiumMetric,
  getCopyLink
} from './CustomReport.new.helpers';
import { PremiumMetricsCta } from './PremiumMetricsCta';
import useLoadingTimerAlert from '../../../../projects/Forecasting/ProjectProgression/ProgressionOverTime/Header/useLoadingTimerAlert';
import LoadingAlert from 'components/base/empty-states/LoadingAlert';

// eslint-disable-next-line max-lines-per-function
const CustomReport = ({
  license,
  report,
  additionalText,
  filters,
  repositories,
  currentTeams,
  toggleModal,
  toggleSnackBar,
  saveDashboard,
  deleteDashboard,
  isTeamLicense,
  myAccount,
  isDashboardNameValid,
  selectTeamId,
  customDashboards,
  selectReportAndRedirect,
  disableTeamPicker,
  setDisableTeamPicker = _.noop,
  gitScopeToggle
}) => {
  const {
    metrics,
    metricsTotal,
    editableReport,
    setEditableReport,
    addMetrics,
    editableFilters,
    availableMetrics,
    services,
    loadingMetrics,
    exportMetricsV3Data,
    localIterations
  } = useCustomReport({
    report,
    filters,
    gitScopeToggle
  });
  const { pullRequestLabels } = usePullRequestLabels();
  const toast = useToast();
  const isPmCustomDashboard = checkIfIsPmCustomDashboard({ report });

  const loadingTimerAlert = useLoadingTimerAlert(loadingMetrics);

  const { getSettingOrDefinitionValue } = useSettingsService();

  const teamsWithExtraData = useSelector(teamsWithExtraSyncedDataSelector);
  const teamsWithExtraDataIds = _.keyBy(teamsWithExtraData, 'id');
  const currentTeam = filters.globallySelectedTeams[0];
  const currentTeamId = _.get(currentTeam, 'id');
  const {
    children = [],
    isParent,
    type
  } = teamsWithExtraDataIds[currentTeamId] || {};
  const isGroup = children.length > 0 || isParent || type === TEAM_TYPES.GROUP;

  // We are using here currentTeam and not from useDoraFeatureFlags as it causing issue of rendered hooks
  const isAllControbutorsTeamSelected =
    currentTeam?.type === TEAM_TYPES.ALL_CONTRIBUTORS;

  const isNewReport = _.get(report, 'is_new', false);

  if (isNewReport) {
    const newTabsClicked = localStorageService().getNewTabsClicked();
    newTabsClicked[report.id] = true;
    localStorageService().setNewTabsClicked({ newTabsClicked });
  }

  // selectedTeam - App Selected Team (Dashboard Team Picker). All Teams - undefined
  // filters.globallySelectedTeams - Metrics filtered by team/multiple teams. All Teams - all-teams
  const [editMode, setEditMode] = useState(false);
  const [isUncheckDefault, setIsUncheckDefault] = useState(false);
  const [retentionDays, setRetentionDays] = useState(
    getRetentionDaysByLicense(license)
  );
  const isNew = editableReport.id === EMPTY_DEFAULT_REPORT.id;

  const shouldSave =
    editableReport.definition.is_editable &&
    (editMode ||
      isNew ||
      !_.isEqual(report, editableReport) ||
      (!isPmCustomDashboard &&
        !_.isEqual(
          {
            selectedContributor: filters.selectedContributor,
            globallySelectedTeams: filters.globallySelectedTeams,
            selectedRepo: filters.selectedRepo,
            selectedService: filters.selectedService,
            selectedLabels: filters.selectedLabels
          },
          editableFilters
        )));

  const {
    is_show_team_dropdown = true,
    is_show_repos_dropdown = true,
    is_show_labels_dropdown = true,
    is_show_members_dropdown = true,
    is_show_all_teams,
    is_multi_teams_allowed,
    max_retention_date = null
  } = _.get(editableReport, 'definition', {});
  const updateValues = values => {
    setEditableReport({ ...editableReport, ...values });
  };

  const isShowToggle =
    is_show_team_dropdown &&
    is_show_repos_dropdown &&
    !isAllControbutorsTeamSelected;
  const shouldShowTeamOrRepoDropdowns =
    is_show_team_dropdown || is_show_repos_dropdown;
  const shouldShowLabelsDropdown = is_show_labels_dropdown;
  const graphRef = useRef(null);
  const newGraphRef = useRef(null);

  const [rowHeight, setRowHeight] = useState(null);

  const metricsFilterByServiceEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.metricsFilterByServiceEnabled
  });

  const isMetricsInspectionComingSoonReport = DEFAULT_REPORT_IDS.includes(
    report?.id
  );

  const resetRowHeight = debounce(() => {
    if (!rowHeight && newGraphRef.current && newGraphRef.current.clientHeight) {
      setRowHeight(newGraphRef.current.clientHeight * 1.06);
    } else if (
      !rowHeight &&
      graphRef.current &&
      graphRef.current.clientHeight
    ) {
      setRowHeight(graphRef.current.clientHeight * 1.06);
    }
  }, 300);

  useEffect(() => {
    setIsUncheckDefault(false);
  }, [currentTeamId]);

  useEffect(() => {
    resetRowHeight();
  }, [newGraphRef.current, graphRef.current]);

  useEffect(() => {
    if (report.id !== EMPTY_DEFAULT_REPORT.id) {
      TrackingService.logEvent(TRACKING.EVENTS.VISIT, {
        page: TRACKING.PAGES.METRICS,
        internal_type: report.internal_type,
        auto_created: _.get(report, 'extended_data.auto_created', false),
        dashboard_name: report.name,
        dashboard_id: report.id
      });
    }

    if (report.internal_type === DASHBOARD_INTERNAL_TYPES.CUSTOM_PM_METRICS) {
      setDisableTeamPicker(true);
    }

    if (max_retention_date) {
      const dateRangeObj = calculateDateRangeBasedOnRetentionAndMaxRetention(
        getRetentionDaysByLicense(license),
        max_retention_date,
        filters.selectedTimeRanges.start_date,
        filters.selectedTimeRanges.end_date
      );

      const { retentionDays, retentionStartDate, retentionEndDate } =
        dateRangeObj;

      BrowserStorageAccessor().session.set(
        SESSION_STORAGE_KEYS.CUSTOM_DASHBOARD_TIMEFRAME,
        JSON.stringify({
          start_date: retentionStartDate,
          end_date: retentionEndDate
        })
      );
      setRetentionDays(retentionDays);
      filters.setSelectedTimeRanges({
        start_date: retentionStartDate,
        end_date: retentionEndDate
      });
    }

    // if Team OR Repo dropdown appear but not BOTH - need to set filter type based on dropdown
    if (!isShowToggle && shouldShowTeamOrRepoDropdowns) {
      filters.setFilterType(
        is_show_team_dropdown ? FILTER_BY.PEOPLE : FILTER_BY.REPO
      );
    }

    const handleResize = () => {
      resetRowHeight();
    };
    window.addEventListener('resize', handleResize);
    return () => {
      setDisableTeamPicker(false);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const saveChanges = async newName => {
    const saveReport = _.cloneDeep(editableReport);
    const access = saveReport.is_public
      ? TRACKING.ACCESS.PUBLIC
      : TRACKING.ACCESS.PRIVATE;

    if (saveReport.id === EMPTY_DEFAULT_REPORT.id) {
      TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
        page: TRACKING.PAGES.METRICS,
        page_tab: TRACKING.PAGE_TABS.DASHBOARD_NEW,
        click_type: TRACKING.CLICK.DASHBOARD_SAVE,
        internal_type: saveReport.internal_type,
        access
      });
    }
    if (newName) {
      TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
        page: TRACKING.PAGES.METRICS,
        page_tab: TRACKING.PAGE_TABS.DASHBOARD_EDIT,
        click_type: TRACKING.CLICK.DASHBOARD_SAVED_AS,
        internal_type: saveReport.internal_type,
        access
      });
      saveReport.id = EMPTY_DEFAULT_REPORT.id;
      saveReport.name = newName;
    }
    if (isPmCustomDashboard) {
      saveReport.extended_data = {
        feature_flag: FEATURE_FLAGS_NAMES.isCustomPmMetricsEnabled
      };
    }
    try {
      await saveDashboard({
        ...saveReport,
        definition: {
          ...saveReport.definition,
          filters: isPmCustomDashboard
            ? {}
            : {
                selectedContributor: filters.selectedContributor,
                globallySelectedTeams: filters.globallySelectedTeams,
                selectedRepo: filters.selectedRepo,
                selectedService: filters.selectedService,
                selectedLabels: filters.selectedLabels
              }
        }
      });
      setEditMode(false);
    } catch (e) {}
  };

  const onChange = (sourceId, sourceIndex, targetIndex) => {
    // This case happens when user clicks on settings button while the mouse is on move and it causes failure to open the modal
    if (!sourceIndex && !targetIndex) return;

    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.METRICS,
      page_tab: isNew
        ? TRACKING.PAGE_TABS.DASHBOARD_NEW
        : TRACKING.PAGE_TABS.DASHBOARD_EDIT,
      hover_type: TRACKING.HOVER.MOVE_METRIC
    });

    const nextState = swap(
      editableReport.definition.widgets,
      sourceIndex,
      targetIndex
    );

    setEditableReport({
      ...editableReport,
      definition: { ...editableReport.definition, widgets: [...nextState] }
    });
  };

  const isFeatureFlagOn = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.enableRepositoryLevelMetrics
  });

  const defaultTeam = !isEqualAllTeams(filters.globallySelectedTeams)
    ? _.get(filters.globallySelectedTeams, '[0]')
    : _.get(currentTeams, [0], []);

  const reportWidgets = _.get(editableReport.definition, 'widgets', []);
  const isTeamGoals =
    _.get(editableReport, 'internal_type', '') ===
    DASHBOARD_INTERNAL_TYPES.TEAM_GOALS;

  const isTeamGoalsAllTeams =
    _.get(editableReport, 'type', '') ===
    EMPTY_DUMMY_ORG_LEVEL_TEAM_GOALS_DASHBOARD.type;

  const reportWidgetsOrdered = isTeamGoals
    ? TEAM_GOALS_WIDGETS_ORDER.map(i =>
        reportWidgets.find(({ id }) => id.toString() === i.toString())
      ).filter(Boolean)
    : reportWidgets;

  const isTeamGoalsEmptyState =
    reportWidgetsOrdered.length === 0 && isTeamGoals;

  const upgradeGoalsEmptyStateEnabledFF = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.upgradeGoalsEmptyStateEnabled
  });

  const shouldShowTeamGoalsUpgradeEmptyState =
    isTeamGoals &&
    upgradeGoalsEmptyStateEnabledFF &&
    LICENSE_SHOW_EMPTY_STATE_FOR_TEAM_GOALS.includes(license.planName);

  if (shouldShowTeamGoalsUpgradeEmptyState) {
    return <TeamGoalsUpgradeEmptyState />;
  }

  if (isTeamGoals && isTeamLicense) {
    return <TeamGoalsCTA />;
  }
  const isShowPersonalInformation = getSettingOrDefinitionValue(
    {
      name: SETTING_NAMES.SHOW_PERSONAL_INFORMATION
    },
    true
  );

  const isShowTeamGoalsAllTeams =
    (isGroup && isTeamGoals) ||
    isTeamGoalsAllTeams ||
    (isAllControbutorsTeamSelected && isTeamGoals);

  const onExportMetricsClicked = async dataFormat => {
    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.METRICS,
      click_type: TRACKING.CLICK.EXPORT_METRICS_CSV,
      data_format: dataFormat
    });
    toast({
      message: (
        <>
          The file is being generated and will be downloaded automatically when
          ready
        </>
      ),
      variant: 'success'
    });
    try {
      const { start_date = '', end_date = '' } = _.get(
        filters,
        'selectedTimeRanges',
        {}
      );
      const fileName = `${report.name} ${start_date}-${end_date}.${dataFormat}`;

      const { url } = await exportMetricsV3Data(dataFormat, fileName);

      downloadLink(url, fileName);
    } catch (exp) {
      toast({
        message: (
          <>There was error generating the CSV file, please try again later!</>
        ),
        variant: 'error'
      });
    }
  };
  const additionalShareMenuItems = [
    <MenuButtonItem
      key='copy-link-to-dashboard'
      text='Copy dashboard link'
      icon={<Icon name='linkicon' color='nepal' size='smaller' />}
      onClick={async () => {
        await navigator.clipboard.writeText(
          getCopyLink(window.location.href, filters)
        );
        toast({
          message: <>Link copied to clipboard</>,
          variant: 'success'
        });
      }}
    />,
    <MenuButtonItem
      key='export-as-csv'
      text='Export as CSV'
      disabled={isPmCustomDashboard || isShowTeamGoalsAllTeams}
      icon={<Icon name='Download' color='nepal' size='smaller' />}
      onClick={() => onExportMetricsClicked('csv')}
    />
  ];

  const userCanAddGraphs = CAN_EDIT_ACCOUNT_TYPES.includes(myAccount?.type_id);

  return (
    <WhiteSection t='1rem' b='1rem' minHeight='100%'>
      <ExportFile>
        <PerformanceTopBar
          reportId={editableReport.id}
          creatorId={editableReport.account_id}
          autoCreated={_.get(report, 'extended_data.auto_created', false)}
          myAccount={myAccount}
          isTeamLicense={isTeamLicense}
          reportName={editableReport.name}
          isNew={editableReport.id === EMPTY_DEFAULT_REPORT.id}
          reportDescription={editableReport.description}
          shouldSave={shouldSave}
          isOnEditMode={isNew || editMode}
          isEditable={editableReport.definition.is_editable}
          updateValues={updateValues}
          saveChanges={saveChanges}
          additionalText={additionalText}
          setEditMode={setEditMode}
          shareMenu={{
            isVisible: true,
            onClick: () => {
              TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
                page: TRACKING.PAGES.METRICS,
                click_type: TRACKING.CLICK.DOWNLOAD_AS_PNG
              });
            },
            pngFileName: `Metrics-${new Date().toISOString()}`,
            additionalMenuElements: additionalShareMenuItems
          }}
          addMetrics={() => {
            TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
              page: TRACKING.PAGES.METRICS,
              page_tab: TRACKING.PAGE_TABS.DASHBOARD_EDIT,
              click_type: TRACKING.CLICK.ADD_METRIC
            });
            addMetrics(toggleModal, isPmCustomDashboard);
          }}
          toggleModal={toggleModal}
          isDashboardNameValid={
            isDashboardNameValid(editableReport.name) ||
            editableReport.name === report.name
          }
          validateName={isDashboardNameValid}
          deleteDashboard={() =>
            toggleModal(
              deleteDashboardModalOption({
                name: editableReport.name,
                close: toggleModal,
                deleteDashboard: async () => {
                  await deleteDashboard(editableReport.id);
                  toggleModal();
                  toggleSnackBar({
                    autoHideDuration: 5000,
                    message: (
                      <Text size='large' color='white'>
                        You just deleted the dashboard "{editableReport.name}"
                      </Text>
                    ),
                    variant: 'success'
                  });
                }
              })
            )
          }
          isPublic={editableReport.is_public}
          togglePrivacy={() =>
            setEditableReport(prevState => ({
              ...prevState,
              is_public: !prevState.is_public
            }))
          }
        >
          {Filters({
            // /next refactor: remove unneccessary props
            pullRequestLabels,
            report: editableReport,
            filters,
            currentTeams,
            repositories,
            services,
            license,
            isTeamLicense,
            isOnEditMode: isNew || editMode,
            isCustom: editableReport.definition.is_editable,
            isShowContributorDropdown:
              !editableReport.definition.is_editable &&
              editableReport.id !== 'pm' &&
              is_show_members_dropdown &&
              isShowPersonalInformation,
            enableRepositoryLevelMetricsSetting: isFeatureFlagOn,
            defaultTeam,
            isShowTeamDropdown: is_show_team_dropdown,
            isShowReposDropdown: is_show_repos_dropdown,
            isShowAllTeams: is_show_all_teams,
            isMultiTeamsAllowed: is_multi_teams_allowed,
            retentionDays,
            isShowToggle,
            shouldShowTeamOrRepoDropdowns,
            shouldShowLabelsDropdown,
            metricsFilterByServiceEnabled,
            isUncheckDefault,
            setIsUncheckDefault
          })}
        </PerformanceTopBar>

        <PmDataProvider>
          <GraphsContainer className='maxHeight'>
            {loadingTimerAlert && (
              <div className='absolute left-10 top-9 z-[999]'>
                <LoadingAlert
                  title={loadingTimerAlert?.title}
                  description={loadingTimerAlert?.description}
                />
              </div>
            )}
            {isShowTeamGoalsAllTeams ? (
              <TeamGoalsAllTeams />
            ) : isTeamGoalsEmptyState ? (
              <TeamGoalsEmptyState
                history={history}
                selectTeamId={selectTeamId}
                globallySelectedTeamId={filters.firstGloballySelectedTeamId}
              />
            ) : (
              <GridContextProvider onChange={onChange}>
                <GridDropZone
                  disableDrag={
                    !editableReport.definition.is_editable || !editMode
                  }
                  disableDrop={
                    !editableReport.definition.is_editable || !editMode
                  }
                  id='widgets'
                  boxesPerRow={3}
                  rowHeight={rowHeight || 368.55}
                  style={{
                    height: `${calculateReportHeight(
                      reportWidgetsOrdered,
                      editableReport.definition.is_editable,
                      userCanAddGraphs
                    )}rem`
                  }}
                >
                  {reportWidgetsOrdered.map((graph, idx) => {
                    const onWidgetChanged = (
                      newWidget,
                      cleanFilters = true
                    ) => {
                      const widgets = [...editableReport.definition.widgets];
                      widgets[idx] = newWidget;
                      if (cleanFilters) {
                        delete widgets[idx].filters;
                      }
                      setEditableReport({
                        ...editableReport,
                        definition: {
                          ...editableReport.definition,
                          widgets
                        }
                      });
                    };

                    const onWidgetRemoved = () => {
                      const widgets = [...editableReport.definition.widgets];
                      const deletedGraph = widgets.splice(idx, 1)[0];
                      setEditableReport({
                        ...editableReport,
                        definition: {
                          ...editableReport.definition,
                          widgets
                        }
                      });
                      toggleSnackBar({
                        autoHideDuration: 3000,
                        message: (
                          <Text size='large' color='white'>
                            The metric "{deletedGraph.name}" was removed from
                            this dashboard
                          </Text>
                        ),
                        variant: 'success'
                      });
                      TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
                        page: TRACKING.PAGES.METRICS,
                        page_tab: isNew
                          ? TRACKING.PAGE_TABS.DASHBOARD_NEW
                          : TRACKING.PAGE_TABS.DASHBOARD_EDIT,
                        click_type: TRACKING.CLICK.METRIC_DELETED,
                        metric_name: deletedGraph.name
                      });
                    };

                    const isHidden = shouldHidePremiumMetric(
                      isAllControbutorsTeamSelected,
                      graph
                    );

                    return (
                      <GraphItem
                        key={graph.id?.toString()}
                        iseditable={
                          editableReport.definition.is_editable && editMode
                        }
                      >
                        {isHidden ? (
                          <PremiumMetricsCta
                            graph={graph}
                            isTeamLicense={isTeamLicense}
                          />
                        ) : (
                          <Margin margin='small'>
                            <PMWidgetsDeprecationNotice
                              graph={graph}
                              customDashboards={customDashboards}
                              selectReportAndRedirect={selectReportAndRedirect}
                            />
                            <CustomWidget
                              height='28rem'
                              editMode={editMode}
                              ref={graphRef}
                              isPublic={report.is_public}
                              metrics={metrics}
                              metricsTotal={metricsTotal}
                              loadingMetrics={loadingMetrics}
                              graph={{
                                ...graph,
                                metricType: getMetricType({
                                  graph,
                                  isPmCustomDashboard,
                                  isTeamGoals,
                                  isEditable:
                                    editableReport.definition.is_editable
                                }),
                                isNewReport:
                                  editableReport.id === EMPTY_DEFAULT_REPORT.id,
                                report: editableReport?.name ?? ''
                              }}
                              onChange={(newWidget, cleanFilters = true) =>
                                onWidgetChanged(newWidget, cleanFilters)
                              }
                              onRemove={onWidgetRemoved}
                              filters={filters}
                              iterations={localIterations}
                              shouldHideClickableMessage={
                                !isMetricsInspectionComingSoonReport
                              }
                            />
                          </Margin>
                        )}
                      </GraphItem>
                    );
                  })}
                </GridDropZone>

                {editableReport.definition.is_editable &&
                  !!availableMetrics.length &&
                  userCanAddGraphs && (
                    <AddGraph
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      {...calculateAddButtonPosition(
                        _.get(editableReport.definition, 'widgets', [])
                      )}
                      onClick={() => {
                        TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
                          page: TRACKING.PAGES.METRICS,
                          page_tab: isNew
                            ? TRACKING.PAGE_TABS.DASHBOARD_NEW
                            : TRACKING.PAGE_TABS.DASHBOARD_EDIT,
                          click_type: TRACKING.CLICK.ADD_METRIC,
                          internal_type: editableReport.internal_type
                        });
                        addMetrics(toggleModal, isPmCustomDashboard);
                      }}
                    >
                      <Margin
                        l='small'
                        r='small'
                        b='small'
                        data-html2canvas-hide='true'
                      >
                        <NewGraphBox text='Add metrics' ref={newGraphRef} />
                      </Margin>
                    </AddGraph>
                  )}
              </GridContextProvider>
            )}
          </GraphsContainer>
        </PmDataProvider>
      </ExportFile>
    </WhiteSection>
  );
};

export default CustomReport;
